import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

// Components
import LoadMoreListings from 'src/Components/homeSearch/Listings/LoadMoreListings'
import { useFavoriteListingClickHandler } from 'src/hooks/listings'
import { ChromebotAd } from 'src/Components/homeSearch/Listings/ChromebotAd'
import ListingCard from 'src/Components/homeSearch/ListingCard'

// Selectors
import {
  selectSearchListingsTotal,
  selectFavoriteListingIds,
  selectHomebotListingsSearchLoading,
} from 'src/store/selectors/listings'

// Helpers
import { isThirdOrLastPosition } from 'src/helpers/isThirdOrLastPosition'
import { fetchFavoriteListings } from 'src/actions/favoriteListings'
import { PATH_HELPERS } from 'src/constants/navigation'

import styles from './ListView.module.scss'

const ListView = ({ listings, customerId, onFocus, focusedListing }) => {
  const dispatch = useDispatch()
  const favoriteListingIds = useSelector(selectFavoriteListingIds)
  const loading = useSelector(selectHomebotListingsSearchLoading)
  const listingsTotal = useSelector(selectSearchListingsTotal)
  const handleFavoriteClick = useFavoriteListingClickHandler()

  useEffect(() => {
    dispatch(fetchFavoriteListings(customerId))
  }, [dispatch, customerId])

  return (
    <>
      <div>
        <ul className={styles.listView}>
          {listings?.map((listing, index) => (
            <React.Fragment key={listing.id}>
              <li
                onMouseOver={() => onFocus(listing)}
                onMouseLeave={() => onFocus(null)}
                onFocus={() => onFocus(listing)}
              >
                <Link
                  to={PATH_HELPERS.listing.buildPath(customerId, listing.id)}
                  name={`listing_${listing.id}`}
                >
                  <ListingCard
                    listing={listing}
                    favoriteClick={handleFavoriteClick}
                    focused={listing.id === focusedListing?.id}
                    isFavorite={
                      favoriteListingIds &&
                      favoriteListingIds.includes(listing.id)
                    }
                  />
                </Link>
              </li>
              {isThirdOrLastPosition(listings, index) && (
                <li key='chromebotAd'>
                  <a
                    href={PATH_HELPERS.prodChromebotWebStore.buildPath()}
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <ChromebotAd />
                  </a>
                </li>
              )}
            </React.Fragment>
          ))}
          <li name='list-bottom' />
        </ul>
      </div>
      {!loading && listings?.length < listingsTotal && (
        <div className={styles.loadMoreListingsWrapper}>
          <LoadMoreListings />
        </div>
      )}
    </>
  )
}

ListView.propTypes = {
  listings: PropTypes.array,
  customerId: PropTypes.string.isRequired,
  onFocus: PropTypes.func,
  focusedListing: PropTypes.shape({
    id: PropTypes.string,
  }),
}

export default ListView
